import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PrizeGoalsService {

  prizeGoals: Observable<any[]>;
  page: number = 1;

  constructor(firestore: AngularFirestore) {
    this.prizeGoals = firestore.collection('prize-goals', ref => ref.orderBy('start', 'desc')).valueChanges({ idField: 'ID' });
  }
}
